import React from "react";
import { Instagram, Linkedin, Facebook } from "lucide-react";
import { socialLinks } from "../config/siteConfig";

const ICONS = {
  instagram: Instagram,
  linkedin: Linkedin,
  facebook: Facebook,
};

/**
 * Icônes de réseaux sociaux. Les liens et leur activation se règlent dans
 * src/config/siteConfig.js (un seul endroit à modifier).
 */
const SocialLinks = ({ className = "" }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {socialLinks.map((social) => {
        const Icon = ICONS[social.id];
        if (!Icon) return null;
        return (
          <a
            key={social.id}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={social.label}
            aria-disabled={!social.enabled}
            onClick={(e) => {
              if (!social.enabled) e.preventDefault();
            }}
            className={`w-10 h-10 flex items-center justify-center rounded-full bg-[#DCB071]/20 text-[#21167D] hover:bg-[#21167D] hover:text-[#F5F3EB] transition-colors ${
              !social.enabled ? "opacity-40 cursor-not-allowed" : ""
            }`}
          >
            <Icon className="w-5 h-5" />
          </a>
        );
      })}
    </div>
  );
};

export default SocialLinks;
